import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { locationSearchParse } from '@/util';
import languageNamesMap from './lang/languageNamesMap';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en', // 设置语言环境
  fallbackLocale: 'en',
  silentTranslationWarn: true
});

export default i18n;

const loadedLanguages = []; // 我们的预装默认语言
if (location && location.href) {
  const urlLang = (/\.com\/([a-zA-Z]{2,4}-?[a-zA-Z]{0,2})\/coloros/g.exec(location.href) || [])[1];
  const lang = urlLang ? urlLang : locationSearchParse()['languagetest'] || 'zh';
  loadLanguageAsync(lang);
}

function setI18nLanguage(lang) {
  i18n.locale = lang;
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
}

export function loadLanguageAsync(rawLang) {
  const lang = languageNamesMap[rawLang] || languageNamesMap['global'];
  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      return import(/* webpackChunkName: "lang-[request]" */ `./lang/${lang}`).then(msgs => {
        i18n.setLocaleMessage(lang, msgs.default);
        loadedLanguages.push(lang);
        return setI18nLanguage(lang);
      });
    }
    return Promise.resolve(setI18nLanguage(lang));
  }
  return Promise.resolve(lang);
}
